jQuery(function ($) {
  $(document).ready(function () {
    console.log("ready!");
    $(".contactpersonen-slick-slider").slick({
      dots: true,
      infinite: false,
      adaptiveHeight: true,
      rows: 3,
      slidesPerRow: 2,
      prevArrow: $(".contactpersonen-slick-wrapper .slider-control .prev"),
      nextArrow: $(".contactpersonen-slick-wrapper .slider-control .next"),
      appendDots: $(".count-wrap"),
      customPaging: function (slider, i) {
        var currentSlide = i + 1;
        var totalSlides = slider.slideCount;
        return currentSlide + " van " + totalSlides;
      },
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesPerRow: 4,
            rows: 1,
          },
        },
      ],
    });

    $(".post-slick-slider").slick({
      dots: true,
      infinite: false,
      adaptiveHeight: true,
      rows: 1,
      slidesPerRow: 3,
      prevArrow: $(".post-slick-wrapper .slider-control .prev"),
      nextArrow: $(".post-slick-wrapper .slider-control .next"),
      appendDots: $(".count-wrap"),
      customPaging: function (slider, i) {
        var currentSlide = i + 1;
        var totalSlides = slider.slideCount;
        return currentSlide + " van " + totalSlides;
      },
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesPerRow: 1,
            rows: 1,
          },
        },
      ],
    });

    var autoGalleryCarousel = $(".gallery-auto-carousel");
    var pauseToggleButton = $(".gallery-auto .pause-gallery");
    var isPaused = false; // Start with autoplay enabled

    // Initialize Slick
    autoGalleryCarousel.slick({
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      autoplay: true, // Ensure autoplay starts initially
      autoplaySpeed: 3000,
      prevArrow: $(".gallery-slick-wrapper .slider-control .prev"),
      nextArrow: $(".gallery-slick-wrapper .slider-control .next"),
      appendDots: $(".count-wrap"),
      customPaging: function (slider, i) {
        var currentSlide = i + 1;
        var totalSlides = slider.slideCount;
        return currentSlide + " van " + totalSlides;
      },
      responsive: [
        {
          breakpoint: 1311,
        },
      ],
    });

    // Toggle autoplay on button click
    pauseToggleButton.on("click", function () {
      if (isPaused) {
        autoGalleryCarousel.slick("slickPlay"); // Resume autoplay
        pauseToggleButton.find("span").text("Pauzeren");
        pauseToggleButton.removeClass("paused");
        console.log("Autoplay resumed");
      } else {
        autoGalleryCarousel.slick("slickPause"); // Pause autoplay
        pauseToggleButton.find("span").text("Afspelen");
        pauseToggleButton.addClass("paused");
        console.log("Autoplay paused");
      }

      isPaused = !isPaused; // Toggle state
    });
  });
});
